import React from "react";
import { Link, useLocation } from "react-router";
import { ReportDetails } from "@sscs/types";
import { Button } from "@sscs/ui";
import { AssignmentIcon } from "@sscs/ui/icons";
import { ReportNavigationState } from "Types";
import useReportNavigation from "../../../../components/LinkToReport/useReportNavigation";

type ViewReportProps = {
  id: string;
  report: ReportDetails;
};

const ViewReport = ({ id, report }: ViewReportProps): React.JSX.Element => {
  const { pathname } = useLocation();
  const { reportLink, searchParams } = useReportNavigation(report);
  const reportNavigation = {
    component: Link,
    to: `${reportLink}/?${searchParams}`,
    state: { from: pathname } satisfies ReportNavigationState,
    preventScrollReset: true,
  };

  return (
    <Button id={id} startIcon={<AssignmentIcon />} {...reportNavigation}>
      View report
    </Button>
  );
};

export default ViewReport;
